<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">팝업관리</span>
            <span class="txt">센터 admin, 회원 app, 관리자 app 등에 보여질 팝업 게시글을 관리합니다.</span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <div v-else class="com-table-content">
            <div class="com-btn-area">
                <div class="left-box">
                    <button class="com-setting-btn" @click="categoryPop = true"></button>
                </div>
                <div class="right-box">
                    <router-link class="com-btn gray" to="/madmin/popup/list">목록</router-link>
                    <button v-if="id" class="com-btn blue" @click="createPopup">수정</button>
                    <button v-else class="com-btn blue" @click="createPopup">등록</button>
                </div>
            </div>
            <table class="com-table edit">
                <colgroup>
                    <col style="width: 150px" />
                    <col style="width: auto" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>카테고리</th>
                        <td class="no-padding">
                            <select-form
                                :select-data="['카테고리를 선택하세요.', ...categoryTypeList]"
                                :select-value="['', ...categoryTypeValueList]"
                                :selected-value="categoryId"
                                class="full"
                                @update:set="(val) => (categoryId = val)"
                            ></select-form>
                        </td>
                    </tr>
                    <tr>
                        <th>노출대상</th>
                        <td class="no-padding">
                            <select-form
                                :select-data="['노출대상을 선택하세요.', ...popShowTypeList]"
                                :select-value="['', ...popShowTypeValueList]"
                                :selected-value="popShowType"
                                class="full"
                                @update:set="(val) => (popShowType = val)"
                            ></select-form>
                        </td>
                    </tr>
                    <tr v-if="popShowType === 'A'">
                        <th>센터찾기</th>
                        <td>
                            <div class="find-button" @click="centerPop = true">
                                <input
                                    :value="targetCenter.centerName === '' ? '' : targetCenter.centerName"
                                    placeholder="센터를 입력하세요."
                                    readonly
                                    type="text"
                                    @click="popupCenterSearch"
                                />
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>제목</th>
                        <td>
                            <input ref="refTitle" v-model="title" class="w100p" type="text" />
                        </td>
                    </tr>
                    <tr>
                        <!-- <th>내용</th> -->
                        <th>URL</th>
                        <td>
                            <!-- <ckeditor :editor="editor" v-model="editorData" :config="editorConfig"></ckeditor> -->
                            <input v-model="editorData" class="w100p" type="text" />
                        </td>
                    </tr>
                    <tr>
                        <th>파일 첨부</th>
                        <td class="no-padding">
                            <div class="file-box">
                                <input v-model="fileName" class="design-input" readonly type="text" />
                                <b-form-file
                                    id="file1"
                                    accept=".jpg, .png, .gif"
                                    plain
                                    @change="handleFile"
                                ></b-form-file>
                                <label for="file1">찾아보기</label>
                            </div>
                            <div class="preview-box">
                                <!--                                <button class="com-btn" @click="noticePop = true;noticePopText = false;">미리보기</button>-->
                                <button
                                    class="com-btn"
                                    @click="
                                        noticePop = true;
                                        noticePopText = true;
                                    "
                                >
                                    미리보기
                                </button>
                                <p class="txt">
                                    ※ 이미지는 660px*660px 정사각형 사이즈와 최대 10MB 용량으로 최적화되어 있습니다.
                                </p>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="table-bottom-check flex">
                <div class="com-check">
                    <input id="check-1-1" v-model="showPeriodYn" name="check-1" type="checkbox" />
                    <label for="check-1-1">
                        <strong>노출기간설정</strong>
                        설정한 기간동안 팝업이 어플리케이션에 노출됩니다.
                    </label>
                </div>
                <div class="com-calendar-wrap">
                    <single-calendar :start-date="showStartDate" @update="startDateUpdate"></single-calendar>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar :end-date="showEndDate" @update="endDateUpdate"></single-calendar>
                </div>
            </div>
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link class="com-btn gray" to="/madmin/popup/list">목록</router-link>
                    <button v-if="id" class="com-btn blue" @click="createPopup">수정</button>
                    <button v-else class="com-btn blue" @click="createPopup">등록</button>
                </div>
            </div>
        </div>

        <!-- 설정 팝업 -->
        <div v-show="categoryPop" class="layer-pop category-setting">
            <div class="view-content">
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">카테고리 설정</span>
                    <p class="sub-txt">
                        카테고리의 이름을 추가, 수정 및 삭제 할 수 있습니다.
                        <br />
                        카테고리 삭제 시, 이전에 작성된 해당 카테고리의 게시글은 카테고리가 없이 표시됩니다.
                    </p>
                    <loading-spinner v-if="isLoading"></loading-spinner>
                    <div class="del-box">
                        <div class="input-cnt flex-col">
                            <div
                                v-for="(category, index) in categoryList.infos"
                                v-if="category.deleteYn === false"
                                class="line"
                            >
                                <input :key="index" ref="categoryArray" v-model="category.name" type="text" />
                                <button class="com-btn" @click="deleteCategory(category.id, index)">삭제</button>
                            </div>
                        </div>
                        <div class="add-btn-cnt">
                            <div class="line">
                                <button class="com-btn" @click="addCategory">+추가</button>
                            </div>
                            <p class="txt">
                                <span class="imp">*</span>
                                최대 10개까지 추가 가능합니다.
                            </p>
                        </div>
                    </div>

                    <div class="bottom-btn">
                        <button class="com-btn" @click="onCancle">취소</button>
                        <button class="com-btn blue" @click="saveCategory">저장</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 센터 검색 팝업 -->
        <div v-show="centerPop" class="layer-pop square-type">
            <div class="view-content">
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">센터 검색 결과</span>
                    <div class="top-search-area">
                        <div class="right">
                            <input
                                ref="refCenterName"
                                v-model="centerNameKeyword"
                                class="w220"
                                placeholder="센터명"
                                type="text"
                                v-on:keyup.enter="onEventSearchCenter"
                            />
                            <button class="com-btn" @click="onEventSearchCenter">검색</button>
                        </div>
                    </div>
                    <table class="com-table">
                        <colgroup>
                            <col style="width: 70px" />
                            <col style="width: 280px" />
                            <col style="width: 160px" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th></th>
                                <th>센터명</th>
                                <th>연락처</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="center in searchCenterList" :key="center.id">
                                <td>
                                    <div class="com-radio">
                                        <input
                                            :id="`radio-pop-${center.id}`"
                                            v-model="selectedCenter"
                                            :value="center"
                                            name="radio-pop"
                                            type="radio"
                                        />
                                        <label :for="`radio-pop-${center.id}`"></label>
                                    </div>
                                </td>
                                <td>{{ center.centerName }}</td>
                                <td>{{ center.telNo | phoneNumberFilter }}</td>
                            </tr>
                            <tr v-if="searchCenterList.length === 0">
                                <td colspan="100">등록된 내용이 없습니다.</td>
                            </tr>
                        </tbody>
                    </table>
                    <b-pagination
                        v-model="centerPagingInfo.page"
                        :per-page="centerPagingInfo.limit"
                        :total-rows="centerPagingInfo.totalItems"
                        align="center"
                        aria-controls="my-table"
                        first-class="first"
                        last-class="last"
                        next-class="next"
                        prev-class="prev"
                        @change="handlerPagenation($event, 'center')"
                    ></b-pagination>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="cancelCenterPopup">취소</button>
                        <button class="com-btn blue" @click="centerPick">선택</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 팝업 미리 보기 : 이미지 -->
        <div v-show="noticePop" class="layer-pop notice-pop">
            <div class="view-content">
                <div class="top-area">
                    <button class="close-btn" @click="noticePop = false"></button>
                </div>

                <div class="view-area">
                    <!-- 이미지 일시 -->
                    <img :src="base64data" alt="" />
                    <!-- //이미지 일시 -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import '@ckeditor/ckeditor5-build-classic/build/translations/ko';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { validateSpace } from '@/assets/js/validation.js';
import ClassicEditor from '@/assets/js/ckeditor/ckeditor.js';
import SimpleUpload from '../../../assets/js/ckeditor/simpleUpload';

export default {
    name: 'popupEdit',
    components: { LoadingSpinner },
    watch: {
        showPeriodYn(newValue) {
            if (newValue === false) {
                this.showStartDate = '';
                this.showEndDate = '';
            }
        },
        showStartDate(newValue) {
            if (newValue) {
                this.showPeriodYn = true;
            }
        },
        showEndDate(newValue) {
            if (newValue) {
                this.showPeriodYn = true;
            }
        },
        popShowType(newValue) {
            if (newValue !== 'A') {
                this.targets = [];
            }
        },
    },
    mounted() {
        this.fetchCategory();
        if (this.id) {
            // 수정이면 팝업 상세 가져옴
            this.fetchPopupDetail();
        }
    },
    data() {
        return {
            categoryPop: false,
            centerPop: false,
            noticePop: false,
            noticePopText: false,

            isLoading: false,
            id: this.$route.params.id, // id가 있으면 수정
            categoryList: {
                infos: [],
            },
            categoryTypeList: [],
            categoryTypeValueList: [],
            popShowTypeList: [
                '센터+회원 전체 <small>(센터 admin, 센터 app, 회원 app 전체 공지사항에 노출됩니다.)</small>',
                '센터 전체 <small>(센터 admin, 센터 app 모든 센터 공지사항에 노출됩니다.)</small>',
                '센터 개별 <small>(센터 admin, 센터 app 선택한 1개의 센터 공지사항에 노출됩니다.)</small>',
                '회원 <small>(회원 app전체 공지사항에 노출됩니다.)</small>',
            ], // 노출대상
            popShowTypeValueList: ['T', 'C', 'A', 'B'], // 노출대상 Value 목록
            editor: ClassicEditor,
            editorData: '',
            editorConfig: {
                extraPlugins: [SimpleUpload],
                height: '500px',
                language: 'ko',
                simpleUpload: {
                    uploadUrl: '/admin/api/board/file',
                    headers: {
                        'X-CSRF-TOKEN': 'CSRF-Token',
                    },
                },
            },

            categoryId: '',
            title: null,
            content: null,
            popShowType: '',
            uploadFiles: [], // base64, mimetype, name이 담김. 실제로 서버로 request할 data
            showPeriodYn: false,

            base64data: '', // 업로드 파일 base64 임시 저장
            fetchFileList: [], // 수정화면에서 기존에 첨부되어 있던 파일 정보
            fileName: '', // 새로 업로드할 파일
            deleteFileIds: [], // 삭제되는 첨부파일 fileId 배열

            selectedCategoryId: '',
            selectedPopShowType: '',
            validateMessage: '',

            showStartDate: '',
            showEndDate: '',

            centerNameKeyword: '',
            searchCenterList: [], // 센터명으로 검색된 센터 목록
            selectedCenter: {}, // 센터 검색을 통해 선택한 센터 정보
            targetCenter: {}, // 선택한 센터

            centerPagingInfo: {
                // 센터검색 페이징 정보
                page: 1, // 현재 페이지
                limit: 5, // 한 목록에 표출되는 건수
                totalItems: '', // 총 Item 수
                itemCount: '', // 현재 페이지 item 수
                totalPages: '', // 총 페이지 수
                route: '', // 링크 경로 생성시 프리픽스
            },

            targets: [], // 노출 대상이 센터 개별일때 센터 정보를 담는 곳
        };
    },
    methods: {
        // 페이지 변경 Handler
        handlerPagenation(event) {
            this.centerPagingInfo.page = event;
            this.searchCenter();
        },

        // 센터명 검색 페이징 Param 설정
        setPageParams(meta) {
            this.centerPagingInfo.totalPages = meta.totalPages;
            this.centerPagingInfo.page = meta.currentPage;
            this.centerPagingInfo.totalItems = meta.totalItems;
            this.centerPagingInfo.itemCount = meta.itemCount;
        },

        // 선택 버튼 클릭시
        centerPick() {
            if (Object.keys(this.selectedCenter).length === 0) {
                alert('센터를 선택하세요.');
                return;
            }
            this.targetCenter = this.selectedCenter;
            const targetCenter = [
                {
                    // showTarget: 'CA', // 센터웹어드민 : CA, 앱어드민 : AA, 앱회원 : AC, 해당사항없음 : -
                    // svcType: 'F', // 케어 : F, 센터 : C
                    centerId: this.targetCenter.id,
                },
            ];
            this.targets = targetCenter;

            this.centerPop = false;
            this.searchCenterList = [];
            this.centerNameKeyword = '';
            this.selectedCenter = {};
        },

        // 센터 검색 팝업 취소
        cancelCenterPopup() {
            this.centerPop = false;
            this.searchCenterList = [];
            this.centerNameKeyword = '';
            // this.centerId = '';
        },

        // 센터 검색 팝업
        popupCenterSearch(type) {
            // 페이징 param 초기화
            this.centerPagingInfo = {
                // 직원 페이징 정보
                page: 1, // 현재 페이지
                limit: 5, // 한 목록에 표출되는 건수
                totalItems: '', // 총 Item 수
                itemCount: '', // 현재 페이지 item 수
                totalPages: '', // 총 페이지 수
                route: '', // 링크 경로 생성시 프리픽스
            };
            this.centerPop = true;
            this.$nextTick(function () {
                this.$refs.refCenterName.focus(); // 센터명 ref focus
            });
        },

        // 센터명 검색 API 호출
        searchCenter() {
            api.get('/admin/api/center', {
                params: {
                    searchStr: this.centerNameKeyword,
                    ...this.centerPagingInfo,
                },
            }).then((response) => {
                console.log('===> searchCenterList : ', response.data.items);
                this.setPageParams(response.data.meta);
                this.searchCenterList = response.data.items;
            });
        },

        // 센터 검색 이벤트 발생시 키워드 길이 체크
        onEventSearchCenter(e) {
            if (this.centerNameKeyword.length < 2) {
                return;
            }
            this.searchCenter();
        },

        // center 조회 API
        getCenterData(centerId) {
            return api.get(`/admin/api/center/${centerId}`);
        },

        // 카테고리 가져오기
        async fetchCategory() {
            try {
                this.isLoading = true;
                const { data } = await this.getCategoryList();
                console.log('===> Success Loading categoryList : ', data);
                data.forEach((category) => {
                    // 받아온 data의 key 값을 필요한 값으로만 재배열
                    const tempCategory = {
                        id: category.b_id,
                        largeType: category.b_l_type_cd,
                        smallType: category.b_s_type_cd,
                        name: category.b_namee,
                        deleteYn: category.b_del_yn,
                    };
                    this.categoryList.infos.push(tempCategory);
                });
                this.categoryList.infos.forEach((category) => {
                    // 카테고리 리스트를 select-form 카테고리 목록에 push
                    this.categoryTypeList.push(category.name);
                    this.categoryTypeValueList.push(String(category.id));
                });
                this.isLoading = false;
            } catch (error) {
                console.log(error);
            }
        },

        // 카테고리 목록 조회 API
        getCategoryList() {
            return api.get('/admin/api/board/category', {
                params: {
                    largeType: 'F', // 케어어드민 : F, 센터어드민 : C
                    smallType: 'P', // 팝업 : P, 게시판 : B, 자주하는질문 : F, 일대일문의 : I, 메뉴얼 : M
                },
            });
        },

        // 팝업 등록 API
        postPopup(data) {
            return api.post('/admin/api/board/popup', data);
        },

        // 팝업 수정 API
        putPopup(id, data) {
            return api.put(`/admin/api/board/popup/${id}`, data);
        },

        // 등록, 수정 validation
        validateValues() {
            if (this.popShowType === '' || this.popShowType === null) {
                return '노출대상을 선택하세요.';
            } else if (this.title === '' || this.title === null) {
                this.$nextTick(function () {
                    this.$refs.refTitle.focus();
                });
                return '제목을 입력하세요.';
            }
            // else if(this.editorData === '' || this.editorData === null) {
            //     return '내용을 입력하세요.';
            // }
            else if (this.showPeriodYn === true && (this.showStartDate === '' || this.showEndDate === '')) {
                return '날짜를 선택하세요.';
            } else if (this.showStartDate > this.showEndDate) {
                return '시작일이 종료일보다 빠릅니다.';
            }
        },

        // 팝업 등록, 수정
        async createPopup() {
            const validate = this.validateValues();
            if (validate) {
                alert(validate);
                return;
            }

            this.isLoading = true;
            if (this.id) {
                // 수정
                try {
                    if (this.uploadFiles.length !== 0) {
                        // uploadFiles에 값이 있으면 파일을 수정한것, 기존 파일은 delete 하는것으로 간주
                        this.fetchFileList.forEach((file) => {
                            if (file !== undefined) {
                                this.deleteFileIds.push(parseInt(file.fileId));
                            }
                        });
                    }
                    const updateData = {
                        centerId: 0,
                        categoryId: this.categoryId,
                        title: this.title,
                        content: this.editorData,
                        taskType: 'F', // 케어어드민 : F, 센터어드민 : C
                        showType: this.popShowType,
                        showPeriodYn: this.showPeriodYn,
                        showStartDate: this.showStartDate,
                        showEndDate: this.showEndDate,
                        deleteFileIds: this.deleteFileIds,
                    };

                    if (this.showPeriodYn === false) {
                        delete updateData.showStartDate;
                        delete updateData.showEndDate;
                    }
                    if (this.uploadFiles.length > 0) {
                        // 첨부 파일이 있으면 data에 insert
                        updateData.uploadFiles = this.uploadFiles;
                    }

                    if (Object.keys(this.targetCenter).length !== 0) {
                        // target이 있으면 data에 insert
                        updateData.targets = [this.targets];
                        delete updateData.targets.boardPopupId;
                        delete updateData.targets.centerName;
                        delete updateData.targets.info;
                    }
                    if (this.categoryId === '') {
                        delete updateData.categoryId;
                    }

                    const { data } = await this.putPopup(this.id, updateData);
                    alert('수정 되었습니다.');
                    console.log('===> Success Update Popup : ', data);
                    this.$router.push({ name: 'popupList' });
                } catch (error) {
                    alert('수정 실패했습니다.');
                    console.log(error);
                }
            } else {
                // 등록
                try {
                    const createData = {
                        centerId: 0,
                        categoryId: this.categoryId,
                        title: this.title,
                        content: this.editorData,
                        deleteFileIds: this.deleteFileIds,
                        taskType: 'F', // 케어어드민 : F, 센터어드민 : C
                        showType: this.popShowType,
                        showPeriodYn: this.showPeriodYn,
                        showStartDate: this.showStartDate,
                        showEndDate: this.showEndDate,
                        uploadFiles: this.uploadFiles,
                    };
                    if (this.showPeriodYn === false) {
                        delete createData.showStartDate;
                        delete createData.showEndDate;
                    }
                    if (this.targets.length > 0) {
                        // target이 있으면 data에 insert
                        createData.targets = this.targets;
                    }
                    if (this.categoryId === '') {
                        delete createData.categoryId;
                    }

                    const { data } = await this.postPopup(createData);
                    alert('등록 되었습니다.');
                    console.log('===> Success Create Popup : ', data);
                    this.$router.push({ name: 'popupList' });
                } catch (error) {
                    alert('등록 실패했습니다.');
                    console.log(error);
                }
            }
            this.isLoading = false;
        },

        // 팝업 상세 첨부 파일 리스트 API
        getPopupDetailFileGroup(fileGroupId) {
            return api.get(`/admin/api/board/file-group/${fileGroupId}`);
        },

        // 팝업 상세 Fetch
        async fetchPopupDetail() {
            try {
                this.isLoading = true;
                const { data } = await this.getPopupDetail(this.id);
                this.categoryId = String(data.categoryId === null ? '' : data.categoryId);
                this.title = data.title;
                this.popShowType = data.showType;
                this.taskType = data.taskType;
                this.showPeriodYn = data.showPeriodYn;
                this.showStartDate = data.showStartDate;
                this.showEndDate = data.showEndDate;
                this.editorData = data.content;
                if (this.showPeriodYn === false) {
                    this.showStartDate = '';
                    this.showEndDate = '';
                }
                // boardPopupTarget을 가져와서 targetId로 센터 이름 조회 api 호출 후 데이터 세팅
                if (data.boardPopupTarget.length != 0) {
                    const tempTarget = data.boardPopupTarget;
                    const centerData = await this.getCenterData(tempTarget[0].centerId);
                    tempTarget[0].centerName = centerData.data.centerName;
                    this.targetCenter = tempTarget[0];
                    this.targets = tempTarget[0];
                }

                if (data.fileGroupId) {
                    // fileGroupId가 있으면 파일 목록 fetch
                    const fileGroupData = await this.getPopupDetailFileGroup(data.fileGroupId);
                    console.log('fileGroupData : ', fileGroupData);
                    fileGroupData.data.forEach((file) => {
                        this.fileName = file.name;
                    });
                    this.fetchFileList.push(fileGroupData.data[0]);
                }

                console.log('Success Loading Popup Detail', data);
                this.isLoading = false;
            } catch (error) {
                console.log(error.response.data);
            }
        },

        // 팝업 상세 API
        getPopupDetail(id) {
            return api.get(`/admin/api/board/popup/${id}`);
        },

        // File 핸들러
        async handleFile(e) {
            try {
                console.log(e);
                const file = e.target.files[0];
                let base64data = await this.readFileAsync(file);
                this.base64data = base64data; // 이미지 미리보기
                base64data = base64data.split(',')[1];
                if (base64data === undefined) {
                    alert('비어있는 파일은 첨부할 수 없습니다.');
                    return;
                }
                const fileInfo = {
                    filename: file.name,
                    mimetype: file.type,
                    base64data,
                };

                this.fileName = fileInfo.filename;
                this.uploadFiles.push(fileInfo);
            } catch (error) {
                console.log(error);
                alert('파일 첨부 중 오류가 발생했습니다.');
            }
        },

        // File reader
        readFileAsync(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },

        // 카테고리 아이템 추가
        addCategory() {
            if (this.categoryList.infos.length > 10) {
                alert('카테고리는 최대 10개까지만 추가 가능합니다.');
                return;
            }
            this.categoryList.infos.push({
                largeType: 'F',
                smallType: 'P',
                name: '',
                deleteYn: false,
            });
        },

        // 카테고리 아이템 삭제
        deleteCategory(categoryId, index) {
            console.log(categoryId, index);
            if (categoryId === undefined) {
                this.categoryList.infos.splice(index, 1);
            } else if (categoryId) {
                this.categoryList.infos[index].deleteYn = !this.categoryList.infos[index].deleteYn;
            }
        },

        // 카테고리 저장 API
        postSaveCatetory() {
            return api.post('/admin/api/board/category', this.categoryList);
        },

        // 카테고리 저장
        async saveCategory() {
            const validate = this.validateCategoryValues();
            if (!validate.result) {
                alert(validate.msg);
                this.$nextTick(function () {
                    this.$refs.categoryArray[validate.resultIndex].focus();
                });
                return;
            }
            try {
                const { data } = await this.postSaveCatetory();
                console.log('===> Success Category create : ', data);
                alert('카테고리를 저장했습니다.');
                this.initCategoryValue();
                await this.fetchCategory();
            } catch (error) {
                alert('카테고리 저장 실패했습니다.');
                console.log(error);
            }
        },

        // 카테고리 validation
        validateCategoryValues() {
            const msg = '카테고리명을 다시 확인하세요.';
            let result = true;
            let resultIndex = '';
            this.$refs.categoryArray.some((category, index) => {
                if (!validateSpace(category.value) || category.value.length < 2) {
                    result = false;
                    resultIndex = index;
                    return true;
                }
            });
            return { result, resultIndex, msg };
        },

        // 취소 버튼 클릭 이벤트
        onCancle() {
            this.initCategoryValue();
            this.fetchCategory();
            this.categoryId = this.selectedCategoryId;
            this.popShowType = this.selectedPopShowType;
        },

        // 카테고리 저장전 관련 변수 초기화
        initCategoryValue() {
            this.categoryPop = false;
            this.categoryList = { infos: [] };
            this.categoryTypeList = [];
            this.categoryTypeValueList = [];
            this.selectedCategoryId = this.categoryId; // 이전에 선택했던 카테고리 임시 저장
            this.selectedPopShowType = this.popShowType; // 이전에 선택했던 노출대상 임시 저장
        },

        // a 태그 파일 다운로드 이벤트
        fileDownload(url) {
            api.post(url, {
                responseType: 'blob',
            })
                .then((response) => {
                    const blob = new Blob([response.data], { type: 'image/png' });

                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    const filename = replaceAll(decodeURI(response.headers.filename), '+', ' ');
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.showStartDate = val;
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.showEndDate = val;
        },
    },
};
</script>
<style scoped src="@/assets/js/ckeditor/ckeditor.css"></style>
<!-- ckeditor5 css -->
<style lang="scss" scoped>
.ui-select.full.on {
    // ckeditor가 select-form보다 위에 나타나는 이슈
    z-index: 10;
}

.ck-editor__editable {
    // ckeditor height 설정
    min-height: 500px;
}

a.file-down::after {
    // 첨부 파일 이름 텍스트
    content: ',' attr(file-down);
    margin-right: 5px;
}

a.file-down:last-of-type::after {
    // 첨부 파일 이름 텍스트
    content: '';
}

.layer-pop.notice-pop .view-content .view-area .text-box {
    font-size: 15px;
    line-height: 20px;
    padding: 0;
    text-align: left;
}
</style>
